import React from 'react';
import { FlatList, View } from 'react-native';

import PropTypes from 'prop-types';

import { withTheme, LightThemeColors } from '../../Themes';
import Divider from '../Divider';

import Option from './Option';
import styles from './Options.Styles';

const renderSeparator = theme => (
  <Divider width="100%" height={1} color={theme.colors.picker.dropdownActiveItem} />
);

function Options({ theme, getFlatListRef, flatListRef, flatListProps, optionsStyle, ...props }) {
  return (
    <View style={[styles.container(theme), optionsStyle]}>
      <FlatList
        keyboardShouldPersistTaps={'handled'}
        data={props.items}
        {...flatListProps}
        style={styles.flatlist(theme)}
        nestedScrollEnabled={true}
        ref={getFlatListRef}
        renderItem={({ item, index }) => <Option item={item} index={index} {...props} />}
        ItemSeparatorComponent={() => renderSeparator(theme)}
      />
    </View>
  );
}

Options.defaultProps = {
  theme: LightThemeColors,
};
Options.propTypes = {
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  getFlatListRef: PropTypes.func,
  flatListProps: PropTypes.object,
  items: PropTypes.array,
};

export default withTheme(Options);
